import { render } from "./Ai.vue?vue&type=template&id=12dc8b7a"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__